import { Component } from 'can';
import appContext from 'scripts/app-context';

import template from './satisfi-button.stache';
import { tryToAddButtonListener } from './satisfi-button.controller';

export default Component.extend({
    template: template,
    tag: 'satisfi-button',
    init() {
        appContext.model.on('pill-module-visible', (event, value) => {
            $('.satisfi_chat-button').toggleClass('pill-module-visible', value);
        });
        appContext.model.on('satisfi-loaded', () => {
            $('.satisfi_chat-button').toggleClass(
                'mobile-disabled',
                this.viewModel.mobiledisabled,
            );
        });
        tryToAddButtonListener(0);
    },
    viewModel: {
        define: {
            enabled: {
                value: false,
            },
            mobiledisabled: {
                value: false,
            },
        },
    },
});
